import script from "./BangKeChiTietXuatPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BangKeChiTietXuatPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./BangKeChiTietXuatPrintModal.vue?vue&type=style&index=0&id=0e8b7200&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8b7200"]])

export default __exports__